import React from "react";
import { IconContainer } from "./IconContainer";

export const AdjustmentIcon = ({ ...props }) => (
  <IconContainer {...props} viewBox="0 0 16 16">
    <path
      d="M8.00156 2.99844C8.00156 2.11478 7.28522 1.39844 6.40156 1.39844C5.51791 1.39844 4.80156 2.11478 4.80156 2.99844C4.80156 3.88209 5.51791 4.59844 6.40156 4.59844C7.28522 4.59844 8.00156 3.88209 8.00156 2.99844Z"
      fill="currentColor"
    />
    <path
      d="M13.8016 3.59844C14.1329 3.59844 14.4016 3.32981 14.4016 2.99844C14.4016 2.66707 14.1329 2.39844 13.8016 2.39844L9.40156 2.39844C9.07019 2.39844 8.80156 2.66707 8.80156 2.99844C8.80156 3.32981 9.07019 3.59844 9.40156 3.59844L13.8016 3.59844Z"
      fill="currentColor"
    />
    <path
      d="M4.00156 2.99844C4.00156 3.32981 3.73293 3.59844 3.40156 3.59844H2.20156C1.87019 3.59844 1.60156 3.32981 1.60156 2.99844C1.60156 2.66707 1.87019 2.39844 2.20156 2.39844L3.40156 2.39844C3.73293 2.39844 4.00156 2.66707 4.00156 2.99844Z"
      fill="currentColor"
    />
    <path
      d="M3.40156 13.5984C3.73293 13.5984 4.00156 13.3298 4.00156 12.9984C4.00156 12.6671 3.73293 12.3984 3.40156 12.3984H2.20156C1.87019 12.3984 1.60156 12.6671 1.60156 12.9984C1.60156 13.3298 1.87019 13.5984 2.20156 13.5984H3.40156Z"
      fill="currentColor"
    />
    <path
      d="M13.8016 13.5984C14.1329 13.5984 14.4016 13.3298 14.4016 12.9984C14.4016 12.6671 14.1329 12.3984 13.8016 12.3984H9.40156C9.07019 12.3984 8.80156 12.6671 8.80156 12.9984C8.80156 13.3298 9.07019 13.5984 9.40156 13.5984H13.8016Z"
      fill="currentColor"
    />
    <path
      d="M7.20156 7.99844C7.20156 8.32981 6.93293 8.59844 6.60156 8.59844H2.20156C1.87019 8.59844 1.60156 8.32981 1.60156 7.99844C1.60156 7.66707 1.87019 7.39844 2.20156 7.39844L6.60156 7.39844C6.93293 7.39844 7.20156 7.66707 7.20156 7.99844Z"
      fill="currentColor"
    />
    <path
      d="M13.8016 8.59844C14.1329 8.59844 14.4016 8.32981 14.4016 7.99844C14.4016 7.66707 14.1329 7.39844 13.8016 7.39844H12.6016C12.2702 7.39844 12.0016 7.66707 12.0016 7.99844C12.0016 8.32981 12.2702 8.59844 12.6016 8.59844H13.8016Z"
      fill="currentColor"
    />
    <path
      d="M11.2016 7.99844C11.2016 7.11478 10.4852 6.39844 9.60156 6.39844C8.71791 6.39844 8.00156 7.11478 8.00156 7.99844C8.00156 8.88209 8.71791 9.59844 9.60156 9.59844C10.4852 9.59844 11.2016 8.88209 11.2016 7.99844Z"
      fill="currentColor"
    />
    <path
      d="M8.00156 12.9984C8.00156 12.1148 7.28522 11.3984 6.40156 11.3984C5.51791 11.3984 4.80156 12.1148 4.80156 12.9984C4.80156 13.8821 5.51791 14.5984 6.40156 14.5984C7.28522 14.5984 8.00156 13.8821 8.00156 12.9984Z"
      fill="currentColor"
    />
  </IconContainer>
);
